module.exports = __webpack_public_path__ + "site/img/25.4e237706.jpg";